<abp-modal
  [visible]="isVisible()"
  (visibleChange)="onVisibleChange($event)"
  (closed)="onVisibleChange(false)"
  [suppressUnsavedChangesWarning]="true"
>
  <ng-template #abpHeader>
    <div class="modal-header-title">
        <h3>{{ localizedStrings().title }}</h3>
    </div>
  </ng-template>

  <ng-template #abpBody>
      <div class="row info-row">
        <div class="col-6">
          <span class="info-label">{{ localizedStrings().table }}</span>
          <span class="info-value">{{ tableDisplayName() }}</span>
        </div>
        <div class="col-6">
          <span class="info-label">{{ localizedStrings().technicalName }}</span>
          <span class="info-value">{{ tableTechnicalName() }}</span>
        </div>
      </div>  
      <div class="form-control-container">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input
            type="text"
            class="form-control"
            id="searchField"
            [placeholder]="localizedStrings().searchField"
            [formControl]="searchControl"
          />
        </div>
      </div>
      @if (filteredFields().length > 0) {
        <app-search-result-table
          gridId="technicalNamesGrid"
          [columnDefinitions]="reportColumns()"
          [dataset]="filteredFields()"
          [extraOptions]="tableOptions"
          class="zn-table-container"
        ></app-search-result-table>
      } @else {
        <div class="grid-empty">
          <img src="assets/images/no-results.svg" [alt]="localizedStrings().noResults">
          <p>{{ localizedStrings().noResults }}</p>
        </div>
      }
  </ng-template>

  <ng-template #abpFooter>
    <zn-button [label]="localizedStrings().close" type="primary" size="large" (click)="onVisibleChange(false)"></zn-button>
  </ng-template>
</abp-modal>